import './ORGANIZATION_SDGS_PIECHART_WidgetLayout.css';

import React from 'react';
import SDGsImpact from '../../../../b2b-social/components/payload/parsers/frameworks/SDGsImpact';
import useFwImagePath from '../../../../b2b-frameworks/hooks/useFwImagePath';
import { Avatar, Box } from '@mui/material';
import { fullImagePath } from '../../../../b2b-common/helpers';

const ORGANIZATION_SDGS_PIECHART_WidgetLayout = ({ data, size = 420, locale, showLogo = false }) => {
    const imagePath = useFwImagePath('generic', 2, locale);
    return (
        <Box className={`ORGANIZATION_SDGS_PIECHART_Widget-container`}
            display='flex' flexDirection='column' justifyContent='center' alignItems='center'
            boxSizing={'border-box'} width='100%' height={'100%'} position={'relative'}
        >
            <SDGsImpact
                data={data}
                size={size}
                locale={locale}
            />
            {imagePath && showLogo && (
                <Avatar
                    variant='circular'
                    src={fullImagePath(imagePath)}
                    alt={`FwImage`}
                    sx={{
                        width: '20px',
                        height: '20px',
                        position: 'absolute',
                        top: '0px',
                        right: '0px',
                    }}
                />
            )}
        </Box>
    );
}

export default ORGANIZATION_SDGS_PIECHART_WidgetLayout;